import styled from 'styled-components';

import { media } from 'src/components/base';

export const Text = styled.div`
  max-width: 66%;

  ${media.smallOnly`
    max-width: 100%;
  `};
`;
